// @flow

import { incompleteCnDashboardActions } from '../../../incompleteCn/dashboard/incompleteCnDashboardRedux/incompleteCnDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: {},
  dashboardDataFiltered: [],
  error: null
};

const filterDashboardTableData = (newState, searchStr) => {
  let searchString;
  if (searchStr) {
    searchString = searchStr.toLowerCase().trim();
  } else {
    searchString = null;
  }
  let filteredArr;

  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        (row.cnote &&
          row.cnote.toString() &&
          row.cnote.toString().indexOf(searchString) >= 0) ||
        (row.clientCode &&
          row.clientCode.toString() &&
          row.clientCode
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.dp &&
          row.dp.toString() &&
          row.dp
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.arrivalTime &&
          row.arrivalTime.toString() &&
          row.arrivalTime.toString().indexOf(searchString) >= 0) ||
        (row.weight &&
          row.weight.toString() &&
          row.weight.toString().indexOf(searchString) >= 0) ||
        (row.totalBoxes &&
          row.totalBoxes.toString() &&
          row.totalBoxes.toString().indexOf(searchString) >= 0) ||
        (row.toBranch &&
          row.toBranch.toString() &&
          row.toBranch
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.clientName &&
          row.clientName.toString() &&
          row.clientName
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.clientAsnNumber &&
          row.clientAsnNumber.toString() &&
          row.clientAsnNumber
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0) ||
        (row.clientDcSiteCode &&
          row.clientDcSiteCode.toString() &&
          row.clientDcSiteCode
            .toString()
            .toLowerCase()
            .indexOf(searchString.toLowerCase()) >= 0)
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const incompleteCnDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case incompleteCnDashboardActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case incompleteCnDashboardActions.GET_EXPECTED_ARRIVALS_COUNT: {
      return Object.assign({}, state, action.payload);
    }
    case incompleteCnDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = Object.assign({}, state);
      const filtered = filterDashboardTableData(newState, action.payload);
      return Object.assign({}, state, { dashboardDataFiltered: filtered });
    }
    default: {
      return state;
    }
  }
};

export default incompleteCnDashboardReducer;
